import { InputDateFilter } from '@/components';
import { formatDateAndTime } from '@/utils/formatDate';
import { FilterMatchMode } from 'primereact/api';
import {
  ColumnFilterElementTemplateOptions,
  ColumnProps,
} from 'primereact/column';

export const getTableColumns = (): ColumnProps[] => {
  return [
    {
      field: 'checkbox',
      selectionMode: 'multiple',
      style: { width: '3rem' },
    },
    {
      field: 'codigo',
      header: '#',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'nombre',
      header: 'Viaje',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
    {
      field: 'llegada',
      header: 'ETA',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => formatDateAndTime(rowData?.llegada),
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} displayMenu />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'llegada',
      dataType: 'date',
    },
    {
      field: 'aperturaStacking',
      header: 'Apertura',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => formatDateAndTime(rowData?.aperturaStacking),
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} displayMenu />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'aperturaStacking',
      dataType: 'date',
    },
    {
      field: 'cierreStacking',
      header: 'Cierre',
      filter: true,
      showFilterMenu: true,
      sortable: true,
      body: (rowData) => formatDateAndTime(rowData?.cierreStacking),
      filterElement: (options: ColumnFilterElementTemplateOptions) => (
        <InputDateFilter options={options} displayMenu />
      ),
      headerStyle: { minWidth: '12rem' },
      filterField: 'cierreStacking',
      dataType: 'date',
    },
    {
      field: 'servicio',
      header: 'Servicio',
      filter: true,
      showFilterMenu: true,
      sortable: true,
    },
  ];
};

export const tableFilters = {
  codigo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
  llegada: { value: null, matchMode: FilterMatchMode.DATE_IS },
  servicio: { value: null, matchMode: FilterMatchMode.CONTAINS },
  aperturaStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
  cierreStacking: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
